<h2>Users List</h2>
@if (allUsers?.length > 0) {
  <ul>
    @for (user of allUsers; track user) {
      <li>{{user.name}} is {{user.email}}</li>
    }
  </ul>
}

@if (allUsers?.length === 0) {
  <div>No data available</div>
}